/*
 *  -----------------------------------------------------------------------
 *    <copyright file="summary-section.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

import { useTranslation } from 'hooks';
import { formatDateUTC_DEPRECATED } from 'utils/convertor';
import ItemWrapper from 'views/components/core/item-wrapper';

const SummarySection = ({ siteConfig, siteInfo, datasetDate }: any) => {
    const { t } = useTranslation();

    return (
        <ItemWrapper title={t('summary')} hideItemNumber>
            <div className="summary-flex-wrap">
                {siteConfig.siteActiveDate ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('ra:activeDate')}:</p>
                        {formatDateUTC_DEPRECATED(siteInfo?.Fields['Site.activeDate'], true, 'DD-MMM-YYYY')}
                    </span>
                ) : null}
                {siteConfig.siteCountry ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('country')}:</p>
                        {siteInfo?.Fields['Site.country']}
                    </span>
                ) : null}
                {siteConfig.siteStatus ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('ra:status')}:</p>
                        {siteInfo?.Fields['Site.status']}
                    </span>
                ) : null}
                {siteConfig.monitor ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('admin:monitor')}:</p>
                        {siteInfo?.Fields['Site.monitor']}
                    </span>
                ) : null}
                {siteConfig.numEnrolled ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('cm:enrolledSubjects')}:</p>
                        {siteInfo?.Fields['Site.subjectsEnrolled']}
                    </span>
                ) : null}
                {siteConfig.numScreened ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('cm:screenedSubjects')}:</p>
                        {siteInfo?.Fields['Site.subjectsScreened']}
                    </span>
                ) : null}
                {siteConfig.numScreenFailed ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('cm:screenedFailedSubjects')}:</p>
                        {siteInfo?.Fields['Site.subjectsScreenFailed']}
                    </span>
                ) : null}
                {siteConfig.numRandomised ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('cm:#randomised')}:</p>
                        {siteInfo?.Fields['Site.subjectsRandomized']}
                    </span>
                ) : null}
                {siteConfig.numTreatmentDiscontinued ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('cm:treatmentDiscontinuedSubjects')}:</p>
                        {siteInfo?.Fields['Site.subjectsTxDiscontinued']}
                    </span>
                ) : null}
                {siteConfig.numStudyDiscontinued ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('cm:discontinuedSubjects')}:</p>
                        {siteInfo?.Fields['Site.subjectsStudyDiscontinued']}
                    </span>
                ) : null}
                {siteConfig.numCompleted ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('cm:numCompleted')}:</p>
                        {siteInfo?.Fields['Site.subjectsStudyComplete']}
                    </span>
                ) : null}
                {datasetDate?.isCMR ? (
                    <span className="summary-text-item-wrap">
                        <p className="title">{t('admin:reportGeneratedDate')}:</p>
                        {formatDateUTC_DEPRECATED(datasetDate?.created, true, 'DD-MMM-YYYY HH:mm')}
                    </span>
                ) : null}
            </div>
        </ItemWrapper>
    );
};

export default SummarySection;
